import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const StyledSketchFabContainer = styled.div`
  margin: ${pxToRem(20)};
`
